import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import {LinkButton, ContactButton} from 'ui/button';
import Block from 'ui/block';
import Section from 'components/Section';
import ContactCtaBlock from 'components/contact-cta-block';
import PageCoverSection from 'components/page-cover';

import COVER_PHOTO from 'img/cover.jpg';

import IMG_ECOMMERCE from './img/ecommerce.jpg';
import IMG_TELECOMMUNICATIONS from './img/telecommunication.jpg';
import IMG_LOGISTICS from './img/logistics.jpg';
import IMG_SECURITY from './img/security.jpg';
import IMG_GEOSPATIAL from './img/geospatial.jpg';
import IMG_AGRITECH from './img/agritech.jpg';


const Page = () => (
    <React.Fragment>
        <PageCover/>
        <PageContent/>
    </React.Fragment>
);

export default Page;


function PageCover() {
    return <PageCoverSection image={COVER_PHOTO} slantBottom="up">
        <Section>
            <Block style={{textAlign: 'center'}}>
                <h1 style={{fontSize:'3em',fontWeight:'400'}}>
                    We have experience building products for companies in the following industries
                </h1>
            </Block>
        </Section>
        <ContactCtaBlock />
    </PageCoverSection>;
};


function PageContent() {
    return <React.Fragment>
        <Section>
            <PageItemsContainer>

                <PageItem
                    title="E-Commerce"
                    side="left"
                    coverPhoto={IMG_ECOMMERCE}
                    cta={<LinkButton
                             theme="accent"
                                    to="/ecommerce-automation"
                                    size="default">
                        Read more
                    </LinkButton>}>
                    <p>
                        We enable online retailers to work better
                        and faster, through a suite of powerful
                        automation tools.
                    </p>

                </PageItem>

                <PageItem
                    title="Logistics"
                    side="right"
                    coverPhoto={IMG_LOGISTICS}
                    emailRef="ws:log" />

                <PageItem
                    title="Security & law enforcement"
                    side="left"
                    coverPhoto={IMG_SECURITY}
                    emailRef="ws:sec" />

                <PageItem
                    title="Telecommunications"
                    side="right"
                    coverPhoto={IMG_TELECOMMUNICATIONS}
                    emailRef="ws:telco" />

                <PageItem
                    title="Geospatial"
                    side="left"
                    coverPhoto={IMG_GEOSPATIAL}
                    emailRef="ws:geo" />

                <PageItem
                    title="Agritech"
                    side="right"
                    coverPhoto={IMG_AGRITECH}
                    emailRef="ws:agri" />

            </PageItemsContainer>
        </Section>
    </React.Fragment>;
}


function PageItemsContainer({style, ...props}) {
    props.style = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        ...style,
    };
    return <div {...props} />;
}



function PageItem({title, children, style, side, coverPhoto, cta, emailRef, ...props}) {

    const _sideStyle = (side === 'left') ? {
        // Left side
        alignSelf: 'flex-start',
    } : {
        // Right side
        alignSelf: 'flex-end',
    };

    const _style = {
        width: '600px',
        maxWidth: '100%',
        padding: '0', // Inner will set padding

        marginBottom: '30px',
        height: '400px',

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        ..._sideStyle,
        ...style,
    };

    if (coverPhoto) {
        Object.assign(_style, {
            backgroundImage: `url(${coverPhoto})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        });
    }

    const innerStyle = {
        padding: '60px 40px 40px',
        background: 'rgba(0, 0, 0, 0.6)',
        clipPath: `polygon(
            0 40px,
            0 100%,
            100% 100%,
            100% 0)`,
    };

    let emailSubject = "Enquiry";
    if (emailRef) {
        emailSubject = `[${emailRef}] ${emailSubject}`;
    }

    return <Block theme="dark" style={_style} {...props}>
        <div style={innerStyle}>

            <SplitTitle
                title={title}
                cta={cta || <ContactCTA {...{emailSubject}} />} />

            {children}
        </div>
    </Block>;
}

PageItem.propTypes = {
    side: PropTypes.oneOf(['left', 'right']).isRequired,
    emailRef: PropTypes.string,
};

PageItem.defaultProps = {
    side: 'left',
};


function SplitTitle({title, cta}) {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'row',
    };
    return <div style={containerStyle}>
        <div style={{flex: '1'}}>
            <h2>{title}</h2>
        </div>
        <div>
            {cta}
        </div>
    </div>;
}


function ContactCTA(props) {
    return <ContactButton {...props} />;
}

ContactCTA.defaultProps = {
    theme: 'accent',
    children: 'Contact us',
};



// WEBPACK FOOTER //
// ./src/pages/industries/index.js